import { render } from "./AssTeacherMaster.vue?vue&type=template&id=3792785c&scoped=true"
import script from "./AssTeacherMaster.vue?vue&type=script&lang=js"
export * from "./AssTeacherMaster.vue?vue&type=script&lang=js"

import "./AssTeacherMaster.vue?vue&type=style&index=0&id=3792785c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3792785c"]])

export default __exports__